const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isValidUUID(value: string): boolean {
    return UUID_REGEX.test(value);
}

export function buildApiUrl(
    path: string,
    params: Record<string, string>
): string {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            searchParams.set(key, value);
        }
    });
    const query = searchParams.toString();
    return `${process.env.REACT_APP_API_V2_URL}${path}${
        query ? `?${query}` : ""
    }`;
}

export function buildApiUrlWithPath(
    segments: string[],
    params?: Record<string, string>
): string {
    const encodedPath = segments.map(encodeURIComponent).join("/");
    const path = `/${encodedPath}`;
    if (!params || Object.keys(params).length === 0) {
        return `${process.env.REACT_APP_API_V2_URL}${path}`;
    }
    return buildApiUrl(path, params);
}
